import React from 'react';

import { TextMessageTemplate } from './text-message-template';

import { getTemplateId } from '../utils/template-utils';

type InputProps<T> = {
  templates: Array<T>;
  parser: MessageTemplateParser;
  recipientType: ContactType;
  templateType: TemplateType;
  selectedTemplateId: number | null;

  preventMessageParsing?: boolean;
  useRichText?: boolean;

  onSelect: (templateId: number | null) => void;
  onEdit: (templateId: number | null) => () => void;
  onSave: (template: T, options?: any) => void;
  onDelete: (template: T) => void;
};

export const TemplateList = <T extends Template>({
  selectedTemplateId,
  templates,
  parser,
  onSelect,
  onEdit,
  onDelete,
  preventMessageParsing,
}: InputProps<T>) => (
  <>
    {templates.map((t) => {
      const messageBody = preventMessageParsing ? t.template : parser.parse(t.template);
      const templateId = getTemplateId(t);
      const handleSelect = () => {
        onSelect(templateId);
      };
      return (
        <div key={`template-${t.template}`} className="u-width-100 u-spread">
          <div
            role="presentation"
            className="u-width-100 u-overflow-hidden u-cursor-pointer"
            onClick={handleSelect}
          >
            <TextMessageTemplate
              template={t}
              messageBody={messageBody}
              onEdit={onEdit(getTemplateId(t))}
              onDelete={onDelete}
              isSelected={selectedTemplateId === templateId}
            />
          </div>
        </div>
      );
    })}
  </>
);
